<mat-card class="z2-elevation mat-elevation-z2 toc-card">
  <mat-card-content>
    <h2>{{ documentNode.name }}</h2>

    @if (headers.length === 0) {
      <div class="toc-empty">No TOC entries found — scanned {{ nodes?.length || 0 }} nodes.</div>
    }

    <ul class="toc-list">
      @for (header of headers; track header) {
        <li>
          <a class="toc-link" [href]="'#section-' + header.id" (click)="scrollTo($event, header.id)">
            <span class="toc-number">{{ header.chapterNumber }}</span>
            <span class="toc-title">{{ header.title }}</span>
          </a>
          @if (header.children.length > 0) {
            <ul class="toc-list">
              @for (child of header.children; track child) {
                <li>
                  <a class="toc-link" [href]="'#section-' + child.id" (click)="scrollTo($event, child.id)">
                    <span class="toc-number">{{ child.chapterNumber }}</span>
                    <span class="toc-title">{{ child.title }}</span>
                  </a>
                  @if (child.children.length > 0) {
                    <ul class="toc-list">
                      @for (sub of child.children; track sub) {
                        <li>
                          <a class="toc-link" [href]="'#section-' + sub.id" (click)="scrollTo($event, sub.id)">
                            <span class="toc-number">{{ sub.chapterNumber }}</span>
                            <span class="toc-title">{{ sub.title }}</span>
                          </a>
                        </li>
                      }
                    </ul>
                  }
                </li>
              }
            </ul>
          }
        </li>
      }
    </ul>
  </mat-card-content>
</mat-card>
